import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { fetchExercises, selectExercises } from "../features/workout/exercise/exercise.slice";

const useExercises = () => {
    const dispatch = useAppDispatch();
    const exercises = useAppSelector(selectExercises);

    const getExercises = async () => {
        await dispatch(fetchExercises({searchTerm: '', muscleGroup: ''}));
    }

    useEffect(() => {
        if (exercises.length === 0) {
            getExercises();
        }
    }, []);

    return [exercises];
}
 
export default useExercises;